import React, { Component } from "react";
import WithRoutify from "../../../hoc/WithRoutify";
import WithRouter from "../../../hoc/WithRouter";
import { capitalizeName, decryptString, toQueryString } from "../../../utils/commonUtils";
import TableGrid from "../../../components/UI/TableGrid";
import EmployeeService from "../../../services/EmployeeService";
import { isSet } from "../../../utils/commonUtils";
import Icons from "../../../components/UI/Icons";
import ActivityCharts from "../../EmployeeVisitContainer/EmployeeVisitDetailView/RightContent/ActivityChart/index";
import { getStatusAndColor } from "../../../utils/visitUtils";
import VisitsService from "../../../services/VisitsService";
import withReduxState from "../../../hoc/wReduxState";
import LookupService from "../../../services/LookupService";
import PatientChartsService from "../../../services/PatientChartsService";
import FileManagerService from "../../../services/FileManagerService";
import AddVisits from "../../EmployeeVisitContainer/AddVisits";
import OrganizationService from "../../../services/OrganizationService";
import { encryptString } from "../../../utils/commonUtils";
import PERMISSIONS from "../../../utils/AclPermissions";


class ScreeningsList extends Component {
  constructor(props) {
    super(props);
    const tableHeaders = [
      { label: 'Activity Name', key: 'activity_name' },
      { label: 'Activity Type', key: 'activity_type' },
      { label: 'Status', key: 'status' },
      { label: 'Action', key: 'action', type: 'Actions' },
    ];
    this.state = {
      isActivityChartOpen: false,
      activeChart: null,
      lookupsOptions: {},
      isModelOpen: false,
      visitsAutoFillData: {},
      tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          status: 1000,
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "created_at",
          sort_order: "asc",
          search: {},
        },
      },
    };
  }

  componentDidMount = () => {
    this.fetchPhysical();
    this.fetchLookups();
  }

  componentDidUpdate(prevProps) {
    // Add any logic you want to execute when props are updated
    // You can compare this.props and prevProps to determine changes
  }

  componentWillUnmount() {
    // Add any cleanup logic when the component is about to unmount
  }




  render() {

    const { tableRecords, isActivityChartOpen, activeChart, lookupsOptions, isModelOpen, visitsAutoFillData } = this.state;
    const { patientDetails } = this.props;

    return (
      <>
        {isModelOpen ? (
          <AddVisits
            modelTitle={"Add Visits"}
            fetchVisitsList={this.fetchPhysical}
            isOpen={isModelOpen}
            autoFillData={visitsAutoFillData}
            modalToogleHandler={this.addVisitToogleHandler}
          />
        ) : (
          <></>
        )}
        {
          isActivityChartOpen ?
            <ActivityCharts
              chartDetails={activeChart.activity_data}
              isOpen={false}
              visitDetails={activeChart.visit_data}
              fetchVisitDetails={this.fetchPhysical}
              stateList={this.props.stateList}
              employeeDetails={activeChart.employee_data}
              lookupsOptions={lookupsOptions}
              companyDetails={activeChart.company_data}
              toogleHanlder={this.activityChartToogleHandler}
            />
            :
            <></>

        }
        <div className="w-100 p-2">
          <div className="sh_cardBox h-auto sh_chartboxht shadow-none border">
            <div className="sh_cardHeader">
              <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                <h6 className="text-sm mb-0">Screenings & Tests - {patientDetails.patientName}</h6>
              </div>
            </div>
            <div className="sh_cardBody p-0">
              <TableGrid
                hasPagination={true}
                fetchTableRecords={(filters) =>
                  this.fetchPhysical(filters)
                }
                {...tableRecords} />
            </div>
          </div>
        </div>
      </>
    );
  }
  addVisitToogleHandler = (visitData = false) => {
    let updatedState = { ...this.state };
    
    // If visitData is provided (visit object), pre-fill patient data
    if (visitData && typeof visitData === 'object' && (visitData.employee_id || visitData.employee?.employee_id)) {
      updatedState = {
        ...updatedState,
        ["visitsAutoFillData"]: {
          company_id: visitData.company_id || '',
          employee_id: visitData.employee_id || visitData.employee?.employee_id || '',
          organization_id: OrganizationService.getOrgId(),
        },
        ["isModelOpen"]: !this.state.isModelOpen,
      };
    } else if (visitData === true) {
      // Handle boolean flag for empty auto fill data (backward compatibility)
      updatedState = {
        ...updatedState,
        ["visitsAutoFillData"]: {},
        ["isModelOpen"]: !this.state.isModelOpen,
      };
    } else {
      // Default: just toggle modal without pre-filling
      updatedState = {
        ...updatedState,
        ["isModelOpen"]: !this.state.isModelOpen,
      };
    }
    
    this.setState(updatedState);
  }

  fetchPhysical = async (query = {}) => {
    const { tableRecords } = this.state;
    const queryString = toQueryString({
      ...tableRecords.pagination,
      ...query,
    });
    const payload = {
      type: 'physical',
      hasPagination: true,
      employee_id: this.props.patientDetails.employee_id,
      ...queryString
    }
    let tableRows = [];
    this.props.setLoader(true);
    const response = await EmployeeService.getEmployeeCharts(payload);
    this.props.setLoader(false);
    console.log('response', response);

    response.data.forEach((item, itemIndex) => {
      const { status, statusClr } = getStatusAndColor(item.status);
      let activityData = {
        ...item.activity,
        mapping_id: item.mapping_id,
        visit_id: item.visit_id
      };
      const chartData = {
        activity_data: activityData,
        company_data: item.visit.employee.company,
        visit_data: item.visit,
        employee_data: item.visit.employee
      };
      const currentMeatballDropdownList = [
        {
          className: "btn btn-icon btn-transparent-dark",
          iconType: "Search",
          label: "View Results",
          title: "View Results",
          clickHandler: () => this.navigateToVisitDetails(item.visit_id, item.visit.employee_id)
        },
        {
          className: "btn btn-icon btn-transparent-dark",
          iconType: "Print",
          label: "Print Results",
          title: "Print Results",
          clickHandler: () => this.printActivityResult(item.mapping_id, item.visit_id)
        },
        {
          className: "btn btn-icon btn-transparent-dark",
          iconType: "AddIconDetailView",
          label: "New Appointment",
          title: "Add Visit",
          clickHandler: () => this.addVisitToogleHandler(item?.visit)
        },
        {
          className: "btn btn-icon btn-transparent-dark",
          iconType: "Print",
          label: "Compliance",
          title: "Compliance",
          clickHandler: () => {}
        },
      ];
      tableRows = [
        ...tableRows,
        {
          physicalIndex: itemIndex,
          isHeading: false,
          rowId: item.physical_id,
          data: {
            isActive: false,
            activity_name: {
              value:
                <>
                  <a className="btn btn-icon btn-transparent-dark mr-1" title={status} >
                    <Icons type={statusClr} />
                  </a>
                  {item?.activity?.activity_name}

                </>
            },
            status: {
              title: status,
              value: <>
                <div className="d-flex justify-content-left">
                  <div >{capitalizeName(item.status.toLowerCase())}</div>
                </div>
              </>
            },
            activity_type: item?.activity?.activity_type,
            action: [
              {
                className: "btn btn-icon btn-transparent-dark",
                iconType: "ActivityChart",
                // Deny opening chart for employer users without edit access
                acl: [PERMISSIONS.RESULT.EDIT, PERMISSIONS.VISITS.EDIT],
                title: 'Chart',
                clickHandler: () => this.activityChartToogleHandler(chartData)
              }
              ,
              {
                className:
                  "btn btn-icon btn-transparent-dark",
                iconType: "Remove",
                // Deny deleting screenings activities for employer users
                acl: PERMISSIONS.RESULT.DELETE,
                title: "Delete",
                isDelete: true,
                clickHandler: () => this.deleteHandler(item.mapping_id),
              },
              {      
                // iconType:"NewMeatBallIcon",
                iconType:"MeatBall",
                title: "More",
                // Use currentMeatballDropdownList based on screenType
                iconDropDownList: currentMeatballDropdownList
             } 
            ],
          },
        },
      ];
    });
    this.setState({
      tableRecords: {
        ...this.state.tableRecords,
        tableRows: {
          type: "default",
          data: tableRows,
        },
        pagination: {
          ...this.state.tableRecords.pagination,
          ...query,
          totalRecords: response?.total,
        },
      },
    });
  }
  activityChartToogleHandler = (chartDetails = {}) => {
    this.setState({ isActivityChartOpen: !this.state.isActivityChartOpen, activeChart: chartDetails });
  }

  navigateToVisitDetails = (visitId, employeeId) => {
    const queryParams = new URLSearchParams();
    queryParams.append('employee_id', employeeId);
    queryParams.append('visit_id', visitId);
    this.props.navigate(`/result/physical-drug-screens?${queryParams.toString()}`);
  }
  deleteHandler = async (id) => {
    VisitsService.deleteActivityInChartInVisits(id)
      .then((res) => {
        this.props.Toast.success('Activities Deleted Successfully');
        this.fetchPhysical();
      })
      .catch((err) => {
        //
      })
      .finally(() => {
        //
      });
  }
  printActivityResult = async (mappingId, visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const queryfilters = {
        visit_id: visitId,
      };
      const data = await PatientChartsService.getPrintResult(null, queryfilters, mappingId);
      if (!data) {
        Toast.error("Result Report Not Found");
        Loader(false);
        return;
      }
      const pdfData = {
        file_content: data,
        original_name: "activity-result",
        mime_type: "application/pdf",
      };
      FileManagerService.printPdf(pdfData);
    } catch (e) {
      console.error("Error printing Activity Result:", e);
      Toast.error("Error while fetching Activity Result");
    } finally {
      Loader(false);
    }
  }
  fetchLookups = async () => {
    const [chartResult, shippingService] = await Promise.all([
      LookupService.getLookupByKey('chart_result'),
      LookupService.getLookupByKey('shipping_service'),
    ]);
    let shippingServiceOptions = [{ label: '-None-', value: '' }];
    isSet(shippingService, []).forEach((item) => {
      shippingServiceOptions.push({
        label: item.value,
        value: item.value
      });
    });
    let chartResultOptions = [{ label: '-None-', value: '' }];
    isSet(chartResult, []).forEach((item) => {
      chartResultOptions.push({
        label: item.value,
        value: item.value
      });
    });
    this.setState({
      lookupsOptions: {
        shippingService: shippingServiceOptions,
        chartResult: chartResultOptions
      }
    })
  }
}

export default withReduxState(WithRouter(WithRoutify(ScreeningsList)));
